export default [
  {
    path: '/attendance/:protocol?',
    name: 'attendance',
    component: () =>
      import('@/modules/attendance/presentation/views/AttendancePage.vue'),
  },
];
